// Configuration du module système AnnouncementBanner
import type { ComponentMetadata } from '../../G&CSCM/Core/types';

export const AnnouncementBannerConfig: ComponentMetadata = {
    name: 'AnnouncementBanner',
    displayName: 'Bannière Annonces',
    description: 'Affiche les annonces importantes (module système requis)',
    category: 'System',
    defaultParams: {},
    paramDefinitions: {},
    outsideGrid: true, // Toujours en dehors de la grille
    defaultEnabled: true
};

export default AnnouncementBannerConfig;


